import React from 'react'
import camelCase from 'lodash/camelCase'
import snakeCase from 'lodash/snakeCase'

import BookmarksIcon from '@material-ui/icons/Bookmarks'
import PeopleIcon from '@material-ui/icons/People'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks'
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark'
import FormatQuoteIcon from '@material-ui/icons/FormatQuote'
import StarsIcon from '@material-ui/icons/Stars'
import VisibilityIcon from '@material-ui/icons/Visibility'
import NoteAddIcon from '@material-ui/icons/NoteAdd'
import EditIcon from '@material-ui/icons/Edit'
import PublicIcon from '@material-ui/icons/Public'
import PostAddIcon from '@material-ui/icons/PostAdd'
import AudiotrackIcon from '@material-ui/icons/Audiotrack'
import MapIcon from '@material-ui/icons/Map'
import ColorLensIcon from '@material-ui/icons/ColorLens'
import Icon from '@material-ui/core/Icon'

import { colors } from 'theme'

const PageIcon = ({ icon = 'fallback', iconColor = 'disabled', ...props }) => {
  const OldIconComponent = {
    overview: VisibilityIcon,
    addPage: NoteAddIcon,
    edit: EditIcon,
    chapterSummariesAnalyses: BookmarksIcon,
    storySummaryAnalysis: BookmarksIcon,
    keyFigures: PeopleIcon,
    characterAnalysis: PeopleIcon,
    themesSymbolsMotifs: StarsIcon,
    importantQuotations: FormatQuoteIcon,
    indexOfTerms: LibraryBooksIcon,
    literaryDevices: CollectionsBookmarkIcon,
    furtherReadingResources: PostAddIcon,
    contextualAnalysis: MapIcon,
    background: PublicIcon,
    essayTopics: DoneAllIcon,
    page: PublicIcon,
    audio: AudiotrackIcon,
    custom: ColorLensIcon,
    fallback: StarsIcon,
  }[camelCase(icon)]

  const IconComponent = OldIconComponent || Icon

  return (
    <IconComponent
      style={{
        color:
          iconColor === 'disabled' ? 'rgba(0, 0, 0, 0.26)' : colors.navyblue,
      }}
      {...props}
    >
      {snakeCase(icon)}
    </IconComponent>
  )
}

export default PageIcon
